import { FC } from 'react';

import { Thead, Tr, Th } from '@chakra-ui/react';
import classNames from 'classnames';

import { TableHeaderProps } from './Table.d';

const TableHeader: FC<TableHeaderProps> = ({ titleList }) => {
  return (
    <Thead className={classNames('fw-bolder text-muted')}>
      <Tr>
        {titleList.map((titleElm, index: Number) => {
          return (
            <Th key={`title-header-${index}`} textAlign="center">
              {titleElm}
            </Th>
          );
        })}
      </Tr>
    </Thead>
  );
};

export default TableHeader;
